var data = {
	"body": "<path d=\"M13 6v12l8.5-6M4 18l8.5-6L4 6v12z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
